/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

import LandingPagePreviewBackground from './LandingPagePreviewBackground.vue';

const __vue_script__ = {
    name: 'LandingPagePreview',

    components: { LandingPagePreviewBackground },

    props: {
        buttonBackgroundColor: {
            type: String,
            default: '#3687FA',
        },

        buttonForegroundColor: {
            type: String,
            default: '#FFFFFF',
        },

        hideCalendar: {
            type: Boolean,
            default: false,
        },

        hideDateInfo: {
            type: Boolean,
            default: false,
        },

        banner: {
            type: Array,
            default: () => [],
        },

        hideFooter: {
            type: Boolean,
            default: true,
        },

        footerText: {
            type: String,
            default: '© YEAR - Name of the company',
        },

        event: {
            type: Object,
            required: true
        },

        settings: {
            type: Object,
            required: true,
        },
    },

    computed: {
        bannerUrl() {
            return get(this.banner, '0.url') || get(this.banner, '0');
        },

        appIconPath() {
            const asset = this.event.is_content_hub ? 'content_hub_theme/favicon' : 'theme/app-icon';
            return this.$utils.assets.getEventAssetPath(this.event._id, asset);
        },

        disableLogin() {
            return this.settings.disable_login;
        },
    },
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "100 96 651 430",
      },
    },
    [
      _c("landing-page-preview-background"),
      !_vm.disableLogin
        ? _c("g", [
            _c("rect", {
              attrs: {
                fill: _vm.buttonBackgroundColor,
                rx: "5",
                height: "18",
                width: "37",
                y: "107",
                x: "674",
              },
            }),
            _c(
              "text",
              {
                attrs: {
                  fill: _vm.buttonForegroundColor,
                  y: "120",
                  x: "692",
                  "text-anchor": "middle",
                  "font-size": "10",
                },
              },
              [_vm._v("Login")]
            ),
          ])
        : _vm._e(),
      !_vm.bannerUrl
        ? _c("rect", {
            attrs: {
              fill: "#F3F3F3",
              height: "137",
              width: "651",
              x: "100",
              y: "136.5",
            },
          })
        : _vm._e(),
      _vm.bannerUrl
        ? _c(
            "foreignObject",
            { attrs: { x: "100", y: "136.5", width: "651", height: "137" } },
            [
              _c("img", {
                attrs: { src: _vm.bannerUrl, width: "651", height: "137" },
              }),
            ]
          )
        : _vm._e(),
      !_vm.hideDateInfo
        ? _c("rect", {
            attrs: {
              fill: "#F3F3F3",
              rx: "3",
              height: "11",
              width: "135",
              y: "313",
              x: "485",
            },
          })
        : _vm._e(),
      !_vm.hideCalendar
        ? _c("g", [
            _c("rect", {
              attrs: {
                fill: "#F3F3F3",
                rx: "5",
                height: "18",
                width: "85",
                y: "107",
                x: "581",
              },
            }),
            _c("rect", {
              attrs: {
                fill: "#F3F3F3",
                rx: "5",
                height: "23",
                width: "24",
                y: "296",
                x: "678",
              },
            }),
            _c("path", {
              attrs: {
                fill: "#2D3339",
                d: "M685.125 314C684.504 314 684 313.495 684 312.875V304.625C684 304.004 684.504 303.5 685.125 303.5H687V302.375C687 302.168 687.168 302 687.375 302C687.582 302 687.75 302.168 687.75 302.375V303.5H692.25V302.375C692.25 302.168 692.418 302 692.625 302C692.832 302 693 302.168 693 302.375V303.5H694.875C695.495 303.5 696 304.004 696 304.625V312.875C696 313.495 695.495 314 694.875 314H685.125ZM684.75 312.875C684.75 313.082 684.918 313.25 685.125 313.25H694.875C695.082 313.25 695.25 313.082 695.25 312.875V307.25H684.75V312.875ZM695.25 304.625V306.5H684.75V304.625C684.75 304.418 684.918 304.25 685.125 304.25H687V305C687 305.207 687.168 305.375 687.375 305.375C687.582 305.375 687.75 305.207 687.75 305V304.25H692.25V305C692.25 305.207 692.418 305.375 692.625 305.375C692.832 305.375 693 305.207 693 305V304.25H694.875C695.082 304.25 695.25 304.418 695.25 304.625ZM686.812 309.5C687.123 309.5 687.375 309.248 687.375 308.938C687.375 308.627 687.123 308.375 686.812 308.375C686.502 308.375 686.25 308.627 686.25 308.938C686.25 309.248 686.502 309.5 686.812 309.5ZM687.375 311.562C687.375 311.873 687.123 312.125 686.812 312.125C686.502 312.125 686.25 311.873 686.25 311.562C686.25 311.252 686.502 311 686.812 311C687.123 311 687.375 311.252 687.375 311.562ZM690 309.5C690.311 309.5 690.562 309.248 690.562 308.938C690.562 308.627 690.311 308.375 690 308.375C689.689 308.375 689.438 308.627 689.438 308.938C689.438 309.248 689.689 309.5 690 309.5ZM690.562 311.562C690.562 311.873 690.311 312.125 690 312.125C689.689 312.125 689.438 311.873 689.438 311.562C689.438 311.252 689.689 311 690 311C690.311 311 690.562 311.252 690.562 311.562ZM693.188 309.5C693.498 309.5 693.75 309.248 693.75 308.938C693.75 308.627 693.498 308.375 693.188 308.375C692.877 308.375 692.625 308.627 692.625 308.938C692.625 309.248 692.877 309.5 693.188 309.5ZM692.625 311.562C692.625 311.873 692.877 312.125 693.188 312.125C693.498 312.125 693.75 311.873 693.75 311.563C693.75 311.264 693.516 311.017 693.224 311.003L693.21 311.002C693.203 311 693.194 311 693.188 311C692.877 311 692.625 311.252 692.625 311.562Z",
                "clip-rule": "evenodd",
                "fill-rule": "evenodd",
              },
            }),
          ])
        : _vm._e(),
      !_vm.appIconPath
        ? _c("g", [
            _c("rect", {
              attrs: {
                x: "440.532",
                y: "294.532",
                width: "35",
                height: "35",
                rx: "4.5",
                fill: "#FFE9CC",
              },
            }),
            _c("rect", {
              attrs: {
                x: "440.532",
                y: "294.532",
                width: "35",
                height: "35",
                rx: "4.5",
                stroke: "#FF9500",
                "stroke-dasharray": "4 4",
              },
            }),
          ])
        : _c("image", {
            attrs: {
              href: _vm.appIconPath,
              x: "440.532",
              y: "294.532",
              width: "35",
              height: "35",
              rx: "4.5",
              "clip-path": "url(#clip_logo)",
            },
          }),
      !_vm.hideFooter
        ? _c("rect", {
            attrs: {
              fill: _vm.buttonBackgroundColor,
              height: "24",
              width: "651",
              x: "100",
              y: "502",
            },
          })
        : _vm._e(),
      !_vm.hideFooter
        ? _c(
            "text",
            {
              attrs: {
                fill: _vm.buttonForegroundColor,
                x: "425",
                y: "518",
                "text-anchor": "middle",
                "font-size": "10",
                lengthAdjust: "spacingAndGlyphs",
              },
            },
            [_vm._v(_vm._s(_vm.footerText))]
          )
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/registrations/preview/LandingPagePreview.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__